import {
    getFileActionCalculate,
    getFileActionImport,
    getFileActionLinks,
    getFileActionOptimize,
    getFileActionSendQuestionnaire,
    getFileActionSendResult,
    getLocalizedExportCategory,
} from './file-action.enum';
import { PollingStatus } from './polling-status.enum';
import { StatusProvider } from './status-provider.enum';

export class PersonalTaxRequest {
    email = '';
    method = '';
    path = '';
    response = -1;
    time = new Date();
    status = PollingStatus.Init;
    statusMessage?: string;
    statusMessageProvider?: StatusProvider;
    localizedAction = '';

    constructor() {
        this.localizedAction = getLocalizedActions().companies;
    }

    deserialize(data: any): this {
        this.email = data.email ?? '';
        this.method = data.method ?? '';
        this.path = data.path ?? '';
        this.response = data.response ?? -1;
        this.time = new Date(data.time) ?? new Date();
        this.status = data.status ?? PollingStatus.Init;
        this.statusMessage = data.status_message ?? undefined;
        this.statusMessageProvider = data.status_message_provider ?? undefined;
        for (let action in getLocalizedActions()) {
            if (this.path.includes(action)) {
                this.localizedAction = getLocalizedActions()[action];
                break;
            }
        }
        return this;
    }

    static Sort(r1: PersonalTaxRequest, r2: PersonalTaxRequest) {
        return r1.time > r2.time ? -1 : 1;
    }
}

export function getLocalizedActions(): Record<string, string> {
    return {
        'imports': getFileActionImport().name,
        'notifications': getFileActionSendResult().name,
        'exports': getLocalizedExportCategory(),
        'calculations': getFileActionCalculate().name,
        'optimizations': getFileActionOptimize().name,
        'links': getFileActionLinks().name,
        'questionnaire/send': getFileActionSendQuestionnaire().name,
        'questionnaire/questions': $localize`:@@personalTaxRequest.editQuestionnaire:Bewerk vragenlijst`,
        'questionnaire/submissions': $localize`:@@personalTaxRequest.submissions:Vraag vragenlijstaanpassingen`,
        'questionnaire/sync-to-silverfin': $localize`:@@personalTaxRequest.syncToSilverfin:Sla vragenlijst op naar Silverfin`,
        'questionnaire/sync-from-silverfin': $localize`:@@personalTaxRequest.syncFromSilverfin:Laad vragenlijst in vanuit Silverfin`,
        'tax-questions': $localize`:@@personalTaxRequest.questions:Bewerk eigen vragen`,
        'companies': $localize`:@@personalTaxRequest.editCompany:Bewerk dossier`,
    };
}
